export const NoComponent = ({ $componentName }: { $componentName: string }) => (
  <div>
    Component <code>{$componentName}</code> does not exist
  </div>
);
